import React from 'react';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { TableHeaderCell } from 'utils/types';
import SortableHeaderCell from './SortableHeaderCell';
import { isEmpty } from 'lodash';
import UnsortableHeaderCell from './UnsortableHeaderCell';
import css from './SortableHeader.scss';

export default class SortableHeader extends React.Component {

  /**
   * Updates the column we're sorting on and the sort direction. If sorting on a new column, sort in ASC order.
   * If sorting on the same column, flip the sort order.
   * @param {string} column - the column to be sorted on
   */
  handleSort = (column) => {
    if (!column || !this.props.onSortChange) return;

    const direction = this.props.columnToSort !== column ? 'ASC' : this.flippedDirection;

    this.props.onSortChange(column, direction);
  };

  // returns the opposite of the given sortDirection
  get flippedDirection() {
    return this.props.sortDirection !== 'ASC' ? 'ASC' : 'DESC';
  }

  // the semantic header configurations expect 'ascending' and 'descending' while our APIs expect 'ASC' and 'DESC'
  get semanticFriendlyDirection() {
    if (this.props.sortDirection === 'ASC') return 'ascending';
    return 'descending';
  }
  
  getWidth = (header) => !this.props.fixed || header.sortValue !== "fullName" ? null : "30%";

  render() {
    return <Table.Row className={css['table-row']}>
      {this.props.headers.map((header, index) =>
        isEmpty(header.sortValue) ?
          <UnsortableHeaderCell header={header}
                                key={index} /> :
          <SortableHeaderCell header={header}
                              style={{width: this.getWidth(header)}}
                              isSorted={header.sortValue === this.props.columnToSort}
                              key={index}
                              sortDirection={this.semanticFriendlyDirection}
                              onSortChange={this.handleSort} />)}
    </Table.Row>
  }

}

SortableHeader.propTypes = {
  columnToSort: PropTypes.string.isRequired,
  headers: PropTypes.arrayOf(TableHeaderCell).isRequired,
  sortDirection: PropTypes.string.isRequired,
  onSortChange: PropTypes.func,
  fixed: PropTypes.bool.isRequired
};
